import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import PromptCard from '../../../PromptCard';
import { blockItemShape } from '../../../../clients/propTypes';
import Wrapper from './styled';

const PathsBlock = ({ items }) => {
  const intl = useIntl();

  return (
    <Wrapper>
      {items.map(({ id, labelId, value }) => (
        <PromptCard
          key={ id }
          copyLabel={ intl.formatMessage({ id: labelId }) }
          copyValue={ value }
          text={ value }
        />
      ))}
    </Wrapper>
  );
};

PathsBlock.propTypes = {
  items: PropTypes.arrayOf(blockItemShape).isRequired
};

export default PathsBlock;
